import React from 'react';

import { getAudienceSegment, IAudienceSegment } from '~/src/dash/api/console-api';
import { IStore } from '~/src/dash/reducers/store';
import {
  extractRouteParams,
  navigate,
  parseLocation,
  RouteAudienceManagerSettingsList,
} from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { AudienceManagerSegmentFormView } from '~/src/dash/views/audience-manager-segment-form-view';
import { LoadingView } from '~/src/dash/views/loading-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState {
  segment?: IAudienceSegment;
  snackbarMessage: string;
  snackbarError: boolean;
}

export const AudienceManagerSegmentExistingView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      segment: undefined,
      snackbarMessage: '',
      snackbarError: false,
    };

    componentDidMount() {
      const loc = parseLocation(this.props.location.pathname);
      getAudienceSegment({
        query: {
          publisher_id: this.props.session.publisher.ID,
          segment_id: loc.audience,
        },
      })
        .then((segment: IAudienceSegment) => {
          this.setState({
            segment,
          });
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage:
                "You don't have access to this audience segment. Please create one or select one in your existiing list.",
              snackbarError: true,
            },
            () => {
              setTimeout(() => {
                navigate(
                  RouteAudienceManagerSettingsList,
                  extractRouteParams({
                    session: this.props.session,
                    user: this.props.user,
                  }),
                );
              }, 3000);
            },
          );
        });
    }

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    render() {
      return (
        <div>
          {this.state.segment ? (
            <AudienceManagerSegmentFormView segment={this.state.segment} />
          ) : (
            <LoadingView active={true} text='Loading the segment settings' />
          )}
          <SnackbarView
            open={!!this.state.snackbarMessage}
            error={!!this.state.snackbarError}
            onClose={this.snackbarClose}
          >
            {this.state.snackbarMessage}
          </SnackbarView>
        </div>
      );
    }
  },
);
